export default "__VITE_ASSET__6D$huK3R__"